import React, {Component} from 'react';
import {Button, Col, Row, Container} from '../Common/reactstrap/lib';
import notFound from '../../imgs/404.png';

export default class NotFoundPage extends Component {
  render() {
    return (
      <Container>
        <Row className="my-5 py-5">
          <Col sm="6" className="text-right pr-5">
            <img src={notFound}/>
          </Col>
          <Col sm="6" className="mt-5 pl-5 pt-4">
            <h1 className="mb-3 mt-5">Такой страницы нет</h1>
            <Button href="/">
              На главную страницу
            </Button>
          </Col>

        </Row>

      </Container>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/NotFoundPage/NotFoundPage.jsx
 **/